import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'

import reducers from '../reducers'

export default function configureStore (initialState) {
  let store
  if (process.env.NODE_ENV !== 'production') {
    store = (composeWithDevTools(applyMiddleware(
      thunkMiddleware
    ))(createStore))(reducers, initialState)
  } else {
    store = (applyMiddleware(
      thunkMiddleware
    )(createStore))(reducers, initialState)
  }

  // Enables Hot Module Replacement of the reducers
  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index').default
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}
